module.exports = __webpack_public_path__ + "img/icon-escalated-white.1b7fca07.svg";